<template>
  <div :style="brandColors" class="vehicle-unit-container">
    <div class="set-thumb-block">
      <div class="vehicle-thumb">
        <div class="vehicle-thumb-container">
          <a class="preview-images" href="#">
            <img
              :alt="vehicle.modelName"
              class="img-responsive ls-is-cached lazyloaded vehicle-img"
              :src="vehicle.angleView"
            />
          </a>
        </div>
      </div>
    </div>
    <div class="vehicle-content">
      <div class="active-template-vehicle-title-block">
        <div class="vehicle-title">
          <a href="#" class="vehicle-link">
            <p class="vehicle-year">2023</p>
            <p class="vehicle-make-model">
              <span class="model">{{ vehicle.modelName }}</span>&nbsp;<span class="vehicle-trim">{{ vehicle.trims[1] }}</span>
            </p>
          </a>
        </div>
        <div class="in-transit-at-dealership-location">
          <span class="vehicle-location">Location: At Dealership</span>
        </div>
        <p></p>
        <div class="vehicle-sub-title">
          <p>
            <span class="vehicle-mileage">13 mi</span>
          </p>
        </div>
      </div>
      <div class="active-template-specs-block">
        <p class="vehicle-spec vehicle-spec--ext-color">
          <span class="vehicle-spec-item vehicle-spec__icon"></span>
          <span class="vehicle-spec-item vehicle-spec__label">Exterior Color: </span>
          <span class="vehicle-spec-item vehicle-spec__value">Polymetal Gray</span>
        </p>
        <p class="vehicle-spec vehicle-spec--int-color">
          <span class="vehicle-spec-item vehicle-spec__icon"></span>
          <span class="vehicle-spec-item vehicle-spec__label">Interior Color: </span>
          <span class="vehicle-spec-item vehicle-spec__value">Black</span>
        </p>
        <p class="vehicle-spec vehicle-spec--stock">
          <span class="vehicle-spec-item vehicle-spec__icon"></span>
          <span class="vehicle-spec-item vehicle-spec__label">Stock: </span>
          <span class="vehicle-spec-item vehicle-spec__value">#123456</span>
        </p>
        <p class="vehicle-spec vehicle-spec--options-modal">
          <span class="vehicle-spec-item vehicle-spec__icon vehicle-spec__icon--has-content">+</span>
          <span class="vehicle-spec__label">
            <a class="toggle-vehicle-options" href="#">View More Vehicle Features</a>
          </span>
        </p>
      </div>
      <div class="vehicle-price">
        <div class="price-container">
          <div class="prices-wrapper">
            <div class="price-wrapper highest-price">
              <h5 class="price-label">MSRP</h5>
              <h3 class="price">${{ numberFormatter(price.market) }}</h3>
            </div>
            <div class="price-wrapper price-savings">
              <h5 class="price-label">Dealer Discount</h5>
              <h3 class="price">$500</h3>
            </div>
            <div class="price-wrapper lowest-price">
              <h5 class="price-label">Our Price</h5>
              <h3 class="price">${{ numberFormatter(price.market - 500) }}</h3>
            </div>
          </div>
        </div>

        <div class="index-btns center-block">
          <a class="btn btn-1 get-price-btn" href="#">Click Here For Your E-price</a>
          <a class="btn btn-2" href="#">Calculate Payments</a>
          <a class="btn btn-3" href="#">Notify Me If Price Drops </a>
          <a class="btn btn-4" href="#">Value Your Trade</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numberWithCommas } from "@/helpers";

export default {
  name: "MazdaGridVehicle",
  props: {
    vehicle: {
      type: Object,
      required: true,
    },
    price: {
      type: Object,
      required: true,
    },
    brandColors: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hovering: false,
      largeBtnTypes: [
        "Locked Price Button",
        "Eprice Button",
        "Eprice Button Variant",
        "Additional Savings Button",
        "Schedule Test Drive Button",
      ],
    };
  },
  computed: {
    selectedPriceBtnImg() {
      return this.selectedPriceBtn.image;
    },
    selectedPriceBtnHoverImg() {
      if (this.selectedPriceBtn.hovered_image) {
        return this.selectedPriceBtn.hovered_image;
      } else {
        return this.selectedPriceBtn.image;
      }
    }
  },
  methods: {
    numberFormatter(num) {
      return numberWithCommas(num);
    },
  },
};
</script>

<style
  scoped
  src="../../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>

@media (max-width: 991px) {
.stacked-srp-prices .single-stacked-price {
  margin-top: 0px;
}
}
.vehicle-unit-container {
  box-shadow: 2px 2px 5px rgb(47, 47, 47, 25%);
}

@media (min-width: 992px) {
  .vehicle-unit-container {
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }

  .vehicle-unit-container:hover {
    -webkit-transform: translateY(-5px);
    -ms-transform: translateY(-5px);
    transform: translateY(-5px);
    -webkit-box-shadow: 0 1px 30px rgb(47, 47, 47, 68%);
    box-shadow: 0 0px 30px rgb(47, 47, 47, 50%);
  }
}

/*vehicle card style*/
.vehicle-content {
  padding: 10px;
}
.vehicle-toggle-btn {
  display: none;
}

.vehicle-index-summary span.pull-right {
  color: rgba(0, 0, 0, 0.87);
  font-size: 12px;
  font-weight: 500;
}

.vehicle-index-summary span {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
}

.vdp-link {
  display: none;
}

/*vehicle price block*/

.vehicle-price .price-container {
  margin: 10px 0px;
}
.vehicle-price h3 {
  font-size: 18px;
}

.vehicle-price h5 {
  font-size: 14px;
}

.vehicle-price .locked-price h3 {
  width: 100%;
  margin: 0;
}

.row.stacked-srp-prices .col-xs-6:first-child {
  width: 100%;
  text-align: center;
}

.vehicle-price-block .vehicle-prices .col-xs-6 {
  width: 100%;
}

.price-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

h5.price-label {
  text-transform: uppercase;
  font-weight: 600 !important;
  margin: 0;
  /* width: 100%; */
  float: none;
}

.price {
  margin: 0;
  /* width: 100%; */
  float: none;
}

.lowest-price h3 {
  font-weight: 600;
}

/*srp grid view*/
#vehicles {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  padding-top: 3px;
}

.vehicle-unit-container {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 3px;
  flex-direction: column;
  justify-content: center;
  width: calc(100% - 20px);
  background-color: #fff;
  padding: 0px;
}

@media (min-width: 768px) {
  #vehicles > .vehicle-unit-container,
  .active-template-wrapper {
    width: calc(50% - 20px);
  }
}

@media (min-width: 1200px) {
  #vehicles > .vehicle-unit-container,
  .active-template-wrapper {
    width: calc(33.333% - 20px);
  }
}

/* Vehicle Unit Container */
.vehicle-unit-container {
  border-radius: 6px;
  padding-bottom: 10px;
  -webkit-box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%) !important;
  box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%) !important;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

@media (min-width: 992px) {
  .vehicle-unit-container:hover {
    -webkit-transform: translateY(-5px);
    -ms-transform: translateY(-5px);
    transform: translateY(-5px);
    -webkit-box-shadow: 0 1px 30px rgb(47, 47, 47, 68%);
    box-shadow: 0 0px 30px rgb(47, 47, 47, 50%);
  }
}

/* Active Template Vehicle Title Block */
.vehicle-unit-container .vehicle-year {
  margin-bottom: 0px;
}
.vehicle-unit-container .vehicle-year,
.vehicle-unit-container .vehicle-make-model {
  font-size: 16px;
  letter-spacing: 1.6px;
  text-transform: uppercase;
}
.vehicle-unit-container .vehicle-make-model {
  font-family: var(--bold-text);
}
.vehicle-unit-container .vehicle-sub-title {
  font-size: 13px;
  border-top: solid 1px #999999;
  border-bottom: solid 1px #999999;
  padding: 7px 0px;
}
.vehicle-unit-container .vehicle-sub-title p {
  margin: 0px;
}

/* Active Template Vehicle Specs Block */
.vehicle-unit-container .active-template-specs-block {
  margin-top: 10px;
  border-bottom: solid 1px #999999;
}
.vehicle-unit-container .active-template-specs-block .vehicle-spec {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.vehicle-spec--options-modal {
  opacity: 0.4;
}
.vehicle-spec--options-modal:hover {
  opacity: 1;
}
.vehicle-spec--options-modal a {
  letter-spacing: 0px !important;
  text-transform: none !important;
}
.vehicle-unit-container .active-template-specs-block .vehicle-spec a {
  color: #333333;
}
.vehicle-location {
    padding: 0;
    display: flex;
    align-items: center;
    font-size: 12px;
}
.vehicle-location:before {
  content: " ";
}
.vehicle-spec__icon, .vehicle-location:before {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  text-align: center;
  width: 20px;
  height: 20px;
  margin-right: 5px;
  background-image: url('../../../static/images/common-icons/mazda-srp-check.png');
  background-size: 40% auto;
  background-repeat: no-repeat;
  background-position: center;
  background-color: rgb(153 153 153 / 30%);
  border-radius: 100%;
}
.vehicle-spec__icon--has-content {
	background-image: none;
  font-weight: bold;
  font-size: 15px;
  line-height: 1.428571429;
}
.vehicle-unit-container .active-template-specs-block .vehicle-spec__label {
  font-weight: bold;
}

/* Active Template Vehicle Price Block */
.vehicle-index-price.vehicle-price-block {
  padding: 20px 0px 0px 0px;
  margin: 0 auto;
}

/* Vehicle Thumb */
.vehicle-thumb-container {
  text-align: center;
}

/* Vehicle Content - New Vehicles */
.vehicle-unit-container.new-true .vehicle-make-model .make {
  display: none;
}

/* Vehicle Features Modal */
#vehicle-options-modal .vehicle-options-block h2 {
  background-color: transparent;
  color: #333333;
  text-align: left;
}
#vehicle-options-modal .table>tbody>tr>td {
  border: 0px;
}
#vehicle-options-modal .table-striped>tbody>tr:nth-of-type(odd) {
  background-color: transparent;
}

/* other */

.row.stacked-vehicle-prices,
.vehicle-price .row {
  margin: auto;
}

.vehicle-price {
  padding: 10px 0px 0px;
}

.vehicle-price .lowest-price h5 {
  margin-top: 5px !important;
}

.vehicle-spex .row {
  margin: auto;
}

.vehicle-price-block .highest-price {
  color: #333;
}
.vehicle-title {
  margin-bottom: 15px;
}
.vehicle-title .vehicle-link {
  color: var(--primary-dark);
}
.vehicle-thumb {
  text-align: center;
}
.btn {
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  padding: 10px;
  margin: 5px auto;
  display: block;
  width: 100%;
  max-width: 300px;
  outline: none;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.btn-1, .btn-3, .btn-2, .btn-4 {
  background: var(--primary-color);
  color: var(--primary-light);
  border: 2px solid var(--primary-color);
  -webkit-transition: .3s all ease;
  -moz-transition: all 0.3s ease;
  -o-transition: .3s all ease;
  transition: .3s all ease;
  
}
.btn-1, .btn-2, .btn-3, .btn-4 {
    display: inline-block;
    background-color: var(--primary-color);
    border: solid 2px var(--primary-color);
    color: #ffffff;
    border-radius: 3px;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 2px;
    text-transform: uppercase;
    padding: 14px 11px;
    margin: 5px 0px;
    max-width: 100%;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
}
.btn-2, .btn-3, .btn-4 {
  background-color: transparent;
  color: var(--primary-color);
}
.btn-1:hover {
  background: transparent;
  color: var(--primary-color);
}
.btn-3:hover, .btn-2:hover, .btn-4:hover {
  background-color: var(--primary-color);
  color: #ffffff;
}
.vehicle-img {
  margin: 30px 0px 10px;
  border-radius: 7px 7px 0 0 !important;
  width: 100%;
}
.get-price-btn-wrapper {
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.get-price-btn {
  cursor: pointer;
  max-width: 100%;
  max-height: 140px;
}

/*vehicle card style*/
.vehicle-toggle-btn {
  display: none;
}
.vehicle-index-summary span.pull-right {
  color: rgba(0, 0, 0, 0.87);
  font-size: 12px;
  font-weight: 500;
}
.vehicle-index-summary span {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
}
.vdp-link {
  display: none;
}

/*vehicle price block*/
.vehicle-price .highest-price h5, .vehicle-price .price-savings h5, .vehicle-price .highest-price h3, .vehicle-price .price-savings h3 {
    margin: 0px 0px 5px 0px;
    font-size: 13px;
    color: #999999;
    letter-spacing: 2px;
}
.vehicle-price .lowest-price h5, .vehicle-price .lowest-price h3 {
  letter-spacing: 2px;
  font-size: 15px;
  margin: 0px 0px 5px 0px;
}
.new-true .row.stacked-srp-prices .col-xs-6 {
  width: 100%;
}
.row.stacked-srp-prices .col-xs-6 {
  width: 100%;
  text-align: center;
}
.new-true .row.stacked-srp-prices .col-xs-6:first-child {
  padding: 0px 0px 15px;
}
.new-true .row.stacked-srp-prices .col-xs-6:first-child .stacked-vehicle-prices {
  margin: auto;
}
.vehicle-price-block .vehicle-prices .col-xs-6 {
  width: 100%;
}
.col-xs-12.highest-price.double-stacked-price {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: baseline;
}
.applied-rebate-savings-block .incentive-label {
  width: 65%;
  text-align: left;
}
</style>